<template>
  <div class="relative flex flex-col py-2 bg-warmGray-50
          text-sm md:text-base "
          v-for="(basketItem, bIdx) in basketItems"
         :key="bIdx"
         :basketItem="basketItem">
         <transition name="slide-fade">
           <basket-item :bIdx="bIdx" :basketItem="basketItem">
           </basket-item>
         </transition>
       </div>
</template>
<script>
import BasketItem from '@/components/BasketItem.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    BasketItem

  },
  computed: {
    ...mapGetters({
      basketItems: 'getCartProducts'
    })

  }
}
</script>
<style scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .4s ease;
}
.slide-fade-leave-active {
  transition: all .18s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
